import React from 'react';

/** Same footer strip as the public landing page (copyright + tagline). */
export default function AuthLandingFooter() {
  return (
    <footer id="contact" className="landing-intro-footer">
      <div className="landing-intro-footer-inner">
        <p>© {new Date().getFullYear()} FamConnect26. All rights reserved.</p>
        <p>
          Created with your family in mind, starting from the grandparents to the youngest family member.
        </p>
      </div>
    </footer>
  );
}
